import type { Ref } from 'vue';
import { computed } from 'vue';
import { SHELL_BREAKPOINTS, useShellBreakpoint } from '@/design-system';

/**
 * Formato do shell da Clínica. O protótipo é explícito: `app.m` abaixo de 1000px, `app.d` a partir
 * de 1000px (Docs/V2/Clinica/clinica/app.jsx). O que muda é só o CHROME — rail no lugar da
 * bottom-nav, paddings e grades; a árvore de rotas é **a mesma** nos dois formatos.
 *
 * Vive em C6 (apresentação) e não em `src/composables/` (C4) de propósito: depende do
 * `useMediaQuery` do Design System (C1), e C4 não alcança C1.
 *
 * O limite vem de `SHELL_BREAKPOINTS.clinica` (Design System), que publica um breakpoint PRÓPRIO
 * da Clínica — não o do Operacional, que só coincide no número. O par TS/CSS mora lá: `bound:
 * 'below'` produz `(max-width: 999.98px)`, exatamente a media query usada em `ClinicPage.vue`.
 */
export const CLINIC_SHELL_SWITCH_PX = SHELL_BREAKPOINTS.clinica.px;

export type ShellMode = 'm' | 'd';

export function useShellMode(): Ref<ShellMode> {
  // `999.98px` e não `999px`: larguras fracionárias existem (zoom, DPR); o limite do protótipo é
  // "menor que 1000", não "até 999". A conversão vive no Design System, não aqui.
  const isMobile = useShellBreakpoint(SHELL_BREAKPOINTS.clinica);
  return computed<ShellMode>(() => (isMobile.value ? 'm' : 'd'));
}
